import { useAuthContext } from "../context/Auth/AuthContext";
import { UserPermissions } from "../../api/grpc/permissions/permissions";

export const useCheckUserPermissions = () => {
  const { user } = useAuthContext();

  const checkUserPermission = (
    permission: UserPermissions | UserPermissions[]
  ) => {
    if (!user) {
      return false;
    }

    return Array.isArray(permission)
      ? permission.some((p) => user?.permissions?.includes(p))
      : user?.permissions?.includes(permission);
  };

  return { checkUserPermission };
};
